export enum CommonReferenceDataPageTypes {
    ALERT_EVENTS = "alertEvents",
    ATTRIBUTE_LABELS = "attributeLabels",
    ATTRIBUTE_LABEL_DETAILS = "attributeLabelDetails",
    DASHBOARD = "dashboard",
    MESSAGING_TEMPLATES = "messagingTemplates",
    MESSAGING_TEMPLATE_DETAILS = "messagingTemplateDetails",
    MESSAGE_TEMPLATES = "messageTemplates",
    MESSAGE_TEMPLATE_DETAILS = "messageTemplateDetails",
    ORGANIZATIONS = "organizations",
    ORGANIZATION_ACTIVITY = "organizationActivity",
    ORGANIZATION_INVITATIONS = "organizationInvitations",
    ORGANIZATION_INVITATION_DETAILS = "organizationInvitationDetails",
    ORGANIZATION_DETAILS = "organizationDetails",
    ORGANIZATION_USERS = "organizationUsers",
    ORGANIZATION_USER_DETAILS = "organizationUserDetails",
    POLICY_COMPONENTS = "policyComponents",
    POLICY_COMPONENT_DETAILS = "policyComponentDetails",
    RELYING_PARTIES = "relyingParties",
    RELYING_PARTY_DETAILS = "relyingPartyDetails",
    SERVICE_TEMPLATES = "serviceTemplates",
    SERVICE_TEMPLATE_DETAILS = "serviceTemplateDetails",
    VERIFICATION_SERVICES = "verificationServices",
    VERIFICATION_SERVICE_DETAILS = "verificationServiceDetails",
    VERIFICATION_TRANSACTIONS = "verificationTransactions",
    VERIFICATION_TRANSACTION_DETAILS = "verificationTransactionDetails",
    WORKFLOW_DETAILS = "workflowDetails",
    WORKFLOW_REPORT = "workflowReport",
    WORKFLOW_TEMPLATES = "workflowTemplates",
    WORKFLOW_TEMPLATE_DETAILS = "workflowTemplateDetails",
    WORKFLOW_USAGE_DETAILS = "workflowUsageDetails",
    WORKFLOWS = "workflows"
}